module.exports = __webpack_public_path__ + "static/icon-birth.fc1de68d.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/icon-birth.png
// module id = 283
// module chunks = 2